const resources = {
    signInButton: 'Sign In',
    signInText: ' to see your loves list.',
    yourLoves: 'Your loves will appear here.'
};

export default function getResource(label) {
    return resources[label];
}
